import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ScreenSizeService } from '../../../services/screen-size.service';

@Component({
  selector: 'app-utility-welcome-screen',
  templateUrl: './utility-welcome-screen.component.html',
  styleUrls: ['./utility-welcome-screen.component.css']
})
export class UtilityWelcomeScreenComponent implements OnInit {

  isMobile: boolean = false;

  constructor(
    private router: Router,
    private screenSizeService: ScreenSizeService
  ) {}

  ngOnInit(): void {
    this.screenSizeService.isMobile$.subscribe(isMobile => {
      this.isMobile = isMobile;
    });
  }

  navigateToLogin() {
    this.router.navigate(['/utility-login'], { queryParams: { mode: 'login' } });
  }

  navigateTo(path: string, mode: string) {
    this.router.navigate([path], { queryParams: { mode } });
  }
}
